import { formatDate } from '@/core/helpers';
import { useTranslation } from 'react-i18next';

interface COALastUpdatedProps {
  date: string;
  role?: string;
  testId?: string;
}

const ROLES_EN: Record<string, string> = {
  SELLER: 'Customer Portal',
  TAX_ADVISOR: 'Tax Advisor Portal',
};

const ROLES_DE: Record<string, string> = {
  SELLER: 'Kundenportal',
  TAX_ADVISOR: 'Portal Steuerberater',
};

export const COALastUpdated = ({ date, role, testId }: COALastUpdatedProps) => {
  const { i18n } = useTranslation();
  const ROLES = i18n.language === 'de' ? ROLES_DE : ROLES_EN;
  return (
    <span
      className='text-sm text-gray-700'
      data-testid={testId || 'last_updated'}
    >
      {formatDate(new Date(date), 'dd.MM.yyyy, HH:mm')} •{' '}
      {role ? ROLES[role] : 'countX'}
    </span>
  );
};
